import { render, staticRenderFns } from "./EditCompanySidebar.vue?vue&type=template&id=485a3358&"
import script from "./EditCompanySidebar.vue?vue&type=script&lang=js&"
export * from "./EditCompanySidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports